<template>
  <div class="ma-auto">
    <title-row
      title="Eszközkezelés"
      :breadcrumb-items="[
        { text: 'Eszközök', to: { name: 'AssetList' } },
        { text: 'Eszközkezelés', disabled: true },
      ]">
    </title-row>

    <v-row>
      <v-col :cols="12">
        <v-card flat class="rounded-xl" style="position: sticky; top: 10px">
          <v-card-title>
            <span>
              <v-icon left>mdi-swap-horizontal-bold</v-icon>
              Eszközök kezelése
            </span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-sheet
                  color="primary"
                  class="d-flex rounded-xl flex-column justify-center align-center"
                  height="160"
                  v-ripple
                  dark
                  style="cursor: pointer"
                  @click="view = Request"
                  title="Kártyatulajdonos eszközhöz való hozzáférésének ellenőrzése">
                  <v-icon size="96">mdi-tray-arrow-up</v-icon>
                  Eszközök kiadása
                </v-sheet>
              </v-col>
              <v-col cols="6">
                <v-sheet
                  color="primary"
                  class="d-flex rounded-xl flex-column justify-center align-center"
                  height="160"
                  v-ripple
                  dark
                  style="cursor: pointer"
                  @click="view = Return"
                  title="Eszköz visszavétele kártyatulajdonostól">
                  <v-icon size="96">mdi-tray-arrow-down</v-icon>
                  Eszközök visszavétele
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col :cols="12" :md="12">
        <v-card flat class="rounded-xl">
          <v-card-title>
            <span>
              <v-icon left>mdi-key-chain</v-icon>
              Tároló
            </span>
          </v-card-title>

          <v-card-text>
            <v-autocomplete
              label="Tároló"
              filled
              :loading="assetCabinetsLoading"
              :items="assetCabinets"
              v-model="assetCabinetId"
              item-text="name"
              item-value="id"
              :value-comparator="$config.comparators.isEqual"
              :hint="!assetCabinetId
                ? 'Nincs tároló kiválasztva. A továbblépéshez válasszon egyet!'
                : ''
              "
              persistent-hint />
            <v-row>
              <v-col :cols="12" :lg="12">
                <v-card
                  v-if="assetCabinetId"
                  flat
                  :loading="assetsLoading"
                  class="pa-2">
                  <v-card-title>
                    Eszközök
                  </v-card-title>
                  <v-card-subtitle>
                    {{ assets.length }} eszköz, ebből {{ takenAssets.length }} van kiadva
                  </v-card-subtitle>
                  <v-row dense class="d-flex align-stretch">
                    <v-col
                      v-for="asset in assets"
                      :key="asset.id"
                      :asset="`asset-${asset.id}`"
                      :cols="12"
                      :md="6"
                      :lg="4"
                      :xl="3">
                      <v-card
                        height="88"
                        flat
                        class="rounded-xl"
                        color="background"
                        :style="{ border: `2px solid ${asset.taken_by ? '#ff8f00' : 'transparent'} !important` }">
                        <div class="pa-3 d-flex align-center">
                          <v-sheet
                            :color="`${asset.color || 'grey'}`"
                            width="8"
                            height="24"
                            rounded="sm"
                            class="mr-2" />
                          <div>
                            <strong>{{ asset.name }}</strong><br />
                            <small>{{ asset.remark }}</small>
                          </div>
                        </div>
                        <div v-if="asset.taken_by" class="flex-grow-1 px-2 py-1 warning white--text text-caption rounded-lg" style="position: absolute; right: 6px; bottom: 6px; top: auto;">
                          {{ asset.taken_by_name }}
                        </div>
                        <div v-else class="flex-grow-1 px-2 py-1 success white--text text-caption rounded-lg" style="position: absolute; right: 6px; bottom: 6px; top: auto;">
                          Tárolóban
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      :value="view"
      @input="
        (v) => {
          view = v ? view : null;
          if (!view) {
            $asyncComputed.assets.update();
          }
        }
      "
      persistent
      fullscreen
      hide-overlay>
      <v-card
        flat
      >
        <v-toolbar color="transparent" elevation="0" class="flex-grow-1">
          <v-toolbar-title v-if="view === Request" class="text-h5">
            <v-btn
              depressed
              large
              class="rounded-xl"
              color="primary"
              @click="view = Return">
              <v-icon left>mdi-tray-arrow-down</v-icon>
              Visszavétel
            </v-btn>
          </v-toolbar-title>
          <v-toolbar-title v-else-if="view === Return" class="text-h5">
            <v-btn
              depressed
              large
              class="rounded-xl"
              color="primary"
              @click="view = Request">
              <v-icon left>mdi-tray-arrow-up</v-icon>
              Kiadás
            </v-btn>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            large
            @click="closeDialog"
            class="rounded-xl">
            <v-icon left>mdi-close</v-icon>
            Bezárás
          </v-btn>
        </v-toolbar>
        <v-sheet max-width="1024" class="mx-auto rounded-xl pt-3" :color="dialogBackgroundColor">
          <component :is="view" @close="closeDialog" @switch-action="(v) => (view = v)"/>
        </v-sheet>
        <v-spacer></v-spacer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Request from './Request.vue';
import Return from './Return.vue';

export default {
  data() {
    return {
      Request,
      Return,
      assetsLoading: false,
      assetCabinetsLoading: false,
      readerDisabled: false,
      response: null,
      lightbox: false,
      assetCabinetId: 0,
      view: null,
      loading: false,
    };
  },

  mounted() {
    this.assetCabinetId =
      this.assetCabinetId || this.$store.getters.config.default_asset_cabinet_id;
  },

  methods: {
    alert(v) {
      console.log(v);
    },

    reset() {
      this.view = null;
      this.readerDisabled = false;
    },

    async fetchAssets() {
      const response = await this.$http.post('assets/list');
      this.assets = response.assets;
    },

    closeDialog() {
      this.view = null;
    },
  },

  computed: {
    takenAssets() {
      return this.assets.filter((a) => a.taken_by);
    },

    dialogBackgroundColor() {
      switch (this.view)
      {
        case this.Request:
          return this.$vuetify.theme.dark ? 'yellow darken-4' : 'warning lighten-3';
        case this.Return:
          return this.$vuetify.theme.dark ? 'blue darken-4' : 'blue lighten-3';
      }
      return 'muted';
    }
  },

  asyncComputed: {
    assetCabinets: {
      async get() {
        this.assetCabinetsLoading = true;
        const response = await this.$http.post('asset-cabinets/list', { nolimit: true });
        this.assetCabinetsLoading = false;
        return response.asset_cabinets;
      },
      default: [],
    },
    assets: {
      async get() {
        this.assetsLoading = true;
        const response = await this.$http.post('assets/list', {
          asset_cabinet_id: this.assetCabinetId,
          nolimit: true,
        });
        this.assetsLoading = false;
        return response.assets;
      },
      default: [],
    },
  },
};
</script>
